import React from 'react';
import PropTypes from "prop-types";
import styled from 'styled-components';

const Description = styled.div`
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    ${({space}) => 
        (space === 'Top' && 'margin-top: 48px') ||
        (space === 'TopDown' && 'margin: 48px 0 16px') || 
        (space === 'None' && 'margin: 0') || 
        'margin-bottom: 16px'
    };
`;
const Icon = styled.div`
    font-size: 0;
    height: 24px;
    flex: 0 0 24px;
    max-width: 24px;
    margin-right: 8px;
    width: 24px;
`;

function RuleDescription({ children, ...props }) {
    return (
        <>
            <Description space={props.space}>
                <Icon>
                    {props.rule && props.rule === 'do' 
                        ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 22">
                            <path fill="#1DCF88" fillRule="evenodd" d="M8.401 15.772L20.694.102 24 2.635 8.715 21.898 0 13.352l2.967-2.909z"/>
                        </svg>
                        : 
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path fill="#EA5949" fillRule="evenodd" d="M12 9.09L21.09 0 24 2.91 14.91 12 24 21.09 21.09 24 12 14.91 2.91 24 0 21.09 9.09 12 0 2.91 2.91 0 12 9.09z"/>
                        </svg>
                    }
                </Icon>
                {children}
            </Description>
        </>
    )
}

RuleDescription.propTypes = {
    rule: PropTypes.string,
    space: PropTypes.string
};

export default RuleDescription